import type * as React from "react";
import { cn } from "../utils/mergeClassNames";

interface IVStackProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
}

const VStack = ({ className, ...props }: IVStackProps) => {
  return (
    <div
      className={cn("flex flex-col", className)}
      {...props}
    />
  );
};
VStack.displayName = "VStack";

export { VStack };
